<template>
    <div :class="['listPage',{shareStyle:$route.query.tabIndex==1}]">
        <div v-if="$route.query.tabIndex==0">
            <div class="rankTable">
                <div class="title">周排名</div>
                <div class="rankingData">{{weekRankingData}}</div>
                <div class="th">
                    <div class="tb">排名</div>
                    <div class="tb">保额<span>(万元)</span></div>
                    <div class="tb">实缴保费<span>(元)/费率</span></div>
                    <div class="tb">省<span>(元)</span></div>
                    <div class="tb">车牌号</div>
                </div>
                <div
                    :class="['td', { odd: i % 2 === 1 }]"
                    v-for="(d, i) in weekRanking"
                    :key="d.ranking"
                >
                    <div class="list">{{ d.ranking }}</div>
                    <div class="list">{{ d.amount }}</div>
                    <div class="list">
                        {{ d.payMoney }}<span>{{ d.rate }}</span>
                    </div>
                    <div class="list">{{ d.saveMoney }}</div>
                    <div class="list">{{ d.plateNo }}</div>
                </div>
            </div>
            <div class="rankTable" style="margin-top:50px">
                <div class="title">月排名</div>
                <div class="rankingData">{{monthRankingData}}</div>
                <div class="th">
                    <div class="tb">排名</div>
                    <div class="tb">保额<span>(万元)</span></div>
                    <div class="tb">实缴保费<span>(元)/费率</span></div>
                    <div class="tb">省<span>(元)</span></div>
                    <div class="tb">车牌号</div>
                </div>
                <div
                    :class="['td', { odd: i % 2 === 1 }]"
                    v-for="(d, i) in monthRanking"
                    :key="d.ranking"
                >
                    <div class="list">{{ d.ranking }}</div>
                    <div class="list">{{ d.amount }}</div>
                    <div class="list">
                        {{ d.payMoney }}<span>{{ d.rate }}</span>
                    </div>
                    <div class="list">{{ d.saveMoney }}</div>
                    <div class="list">{{ d.plateNo }}</div>
                </div>
            </div>
        </div>
        <div v-else>
            <div class="rankTable">
                <div class="title">周排名</div>
                <div class="rankingData">{{weekRankingData}}</div>
                <div class="th">
                    <div class="tb">排名</div>
                    <div class="tb">分享人</div>
                    <div class="tb">转发量</div>
                    <div class="tb">邀请成功量</div>
                </div>
                <div
                    :class="['td', { odd: i % 2 === 1 }]"
                    v-for="(d, i) in shareWeekRanking"
                    :key="d.ranking"
                >
                    <div class="list">{{ d.ranking }}</div>
                    <div class="list">{{ d.shareName }}</div>
                    <div class="list">{{ d.forwardNum }}</div>
                    <div class="list">{{ d.invitationNum }}</div>
                </div>
            </div>
            <div class="rankTable" style="margin-top:50px">
                <div class="title">月排名</div>
                <div class="rankingData">{{monthRankingData}}</div>
                <div class="th">
                    <div class="tb">排名</div>
                    <div class="tb">分享人</div>
                    <div class="tb">转发量</div>
                    <div class="tb">邀请成功量</div>
                </div>
                <div
                    :class="['td', { odd: i % 2 === 1 }]"
                    v-for="(d, i) in shareMonthRanking"
                    :key="d.ranking"
                >
                    <div class="list">{{ d.ranking }}</div>
                    <div class="list">{{ d.shareName }}</div>
                    <div class="list">{{ d.forwardNum }}</div>
                    <div class="list">{{ d.invitationNum }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {getLastWeekData,getLastMonthData,} from "../../common/utils"
const getRankingDataUrl = "/hsbxjj-excellent-driving-insurance/championship/getRankingData";
export default {
    name: "listPage",
    data() {
        return {
            weekRankingData:getLastWeekData().start_day+" - "+getLastWeekData().end_day,
            monthRankingData:getLastMonthData().start_day+" - "+getLastMonthData().end_day,
            weekRanking: [],
            monthRanking: [],
            shareMonthRanking: [],
            shareWeekRanking: [],
        };
    },
    methods: {
        getRankingData() {
            this.$http.post(getRankingDataUrl).then((res) => {
                if (res.data.flag && res.data.data !== null) {
                    this.weekRanking = res.data.data.weekRanking;
                    this.monthRanking = res.data.data.monthRanking;
                    this.shareWeekRanking = res.data.data.shareWeekRanking;
                    this.shareMonthRanking = res.data.data.shareMonthRanking;
                }
            });
        },
    },
    mounted() {
        this.getRankingData();
    },
};
</script>

<style scoped lang="scss">
@function toVw($px) {
        @return $px / 7.5 * 1vw;
    }
.listPage {
    padding-top: toVw(100);
    padding-bottom: toVw(50);
    background:#E7EEFF;
    .rankTable {
        width: toVw(692);
        height: auto;
        background: #ffffff;
        box-shadow: 0 6px 21px 0 rgba(34, 105, 240, 0.17);
        border-radius: toVw(16);
        position: relative;
        margin: 0 auto;
        padding: toVw(44) toVw(6) toVw(10);
        box-sizing: border-box;

        .title {
            width: toVw(229);
            height: toVw(56);
            position: absolute;
            top: toVw(-34);
            left: 50%;
            margin-left: toVw(-114.5);
            font-size: toVw(30);
            line-height: toVw(56);
            font-weight: bold;
            color: #ffffff;
            background: url("../../assets/active/title.png") no-repeat;
            background-size: toVw(229) toVw(56);
        }
        .rankingData{
            font-size: toVw(26);
            color: #4D83FA;
            margin-bottom:toVw(24);
        }

        .th {
            width: toVw(636);
            height: toVw(56);
            background: linear-gradient(90deg, #2565f6 1%, #4d82fa 80%);
            border-radius: toVw(28);
            display: flex;
            justify-content: flex-start;
            align-items: center;
            padding-left: toVw(32);
            box-sizing: border-box;
            margin: 0 auto toVw(13);

            .tb {
                font-size: toVw(26);
                color: #ffffff;

                &:nth-child(2) {
                    margin-left: toVw(16);
                }

                &:nth-child(3) {
                    margin-left: toVw(10);
                }

                &:nth-child(4) {
                    margin-left: toVw(28);
                }

                &:nth-child(5) {
                    margin-left: toVw(26);
                }

                > span {
                    font-size: toVw(20);
                }
            }
        }

        .td {
            width: toVw(680);
            height: toVw(62);
            background: #ffffff;
            font-size: toVw(26);
            color: #1c3264;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            padding-right: toVw(27);
            box-sizing: border-box;

            .list {
                &:nth-child(1) {
                    width: toVw(112.5);
                    text-align: right;
                }

                &:nth-child(2) {
                    width: toVw(80);
                    text-align: left;
                    margin-left: toVw(45);
                }

                &:nth-child(3) {
                    width: toVw(175);
                    text-align: left;
                    margin-left: toVw(20);
                }

                &:nth-child(4) {
                    width: toVw(99);
                    text-align: center;
                }

                > span {
                    font-size: toVw(22);
                    margin-left: toVw(8);
                }
            }
        }

        .odd {
            background: #eaf0fd;
        }
    }
}
.shareStyle{
    background: #FFD8D8;
    .rankTable{
        box-shadow: 0px 6px 21px 0px rgba(255, 36, 36, 0.17);
        .title{
            background: url("../../assets/active/title2.png") 100%/100% no-repeat;
        }
        .rankingData{
            color: #FF3E3E;   
        }
        .th{
            display: flex;
            justify-content: space-around;
            background: linear-gradient(-90deg, #FF2222, #FF5858);
        }
        .td{
            justify-content: space-evenly;
            .list:nth-child(3){
                width: toVw(100);
            }
        }
        .odd{
            background: #FFE9E9;
        }
    }
}
</style>